/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-21 22:05:04
 * @LastEditTime: 2022-01-21 22:30:06
 * @LastEditors: zhao - 🍉
 * @Description: 可动态删减的tags 
 * @FilePath: /zhzj-admin/src/components/Tags/index.jsx
 */
import { Tag, Input, Tooltip, Icon } from 'antd';
import React from "react";
class Tags extends React.Component {
  state = {
    inputVisible: false,
    inputValue: '',
  };

  handleClose = removedTag => {
    const tags = this.props.value.filter(tag => tag !== removedTag);
    this.props.onChange(tags)
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    if (inputValue ) {
        const tags = [...this.props.value, inputValue];
        this.props.onChange(tags)
    }
    this.setState({
      inputVisible: false,
      inputValue: '',
    });
  };

  saveInputRef = input => (this.input = input);

  render() {
    const { inputVisible, inputValue } = this.state;
    return (
      <div>
        {(this.props.value || []).map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag 
                closable
                key={tag} 
                style={{marginBottom:10}}
                onClose={() => this.handleClose(tag)}
            >
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
        {inputVisible && (
          <Input
            ref={this.saveInputRef}
            type="text"
            size="small"
            style={{ width: 78 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {!inputVisible && (
          <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed', cursor: 'pointer' }}>
            <Icon type="plus" /> 
            <span>添加</span>
          </Tag>
        )}
      </div>
    );
  }
}

export default Tags


// WEBPACK FOOTER //
// ./src/components/Tags/index.jsx